// External
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { UiToastComponent } from './ui-toast.component';
import { UiIconModule } from '../ui-icon/ui-icon.module';


@NgModule({
    declarations: [
        UiToastComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        UiIconModule
    ],

    exports: [ UiToastComponent ]

})

export class UiToastModule {}
